import { Observable } from 'rxjs';
import { ApiCacheOptions } from './api-cache-options.model';

export interface IApiService {
  getBaseUrl(): string;

  getDomain(): string;

  get(url: string): Promise<any>;

  getObservable(url: string): Promise<Observable<any>>;

  post(url: string, data: any): Promise<any>;

  put(url: string, data: any): Promise<any>;

  delete(url: string): Promise<any>;

  deleteData(url: string, data: any): Promise<any>;

  getPaged(urlBase: string, params: any): Promise<any>;

  postPaged(urlBase: string, params: any): Promise<any>;

  hasValidAccessToken(url: string): boolean;

  getDefaultApiCacheOptionsForFrequentlyChangedData(): ApiCacheOptions;

  getDefaultApiCacheOptionsForInfrequentlyChangedData(): ApiCacheOptions;

  deleteCache(url: string): void;
  deleteCacheContains(urlContains: string): void;
}
